// openPostDraft.js
'use strict';
import { v4 } from 'uuid';

import {
  POST_SHORT_DIAMOND_DEFAULT,
  POST_VIDEO_DIAMOND_DEFAULT,
  POST_IMAGE_DIAMOND_DEFAULT,
  POST_IMAGES_DIAMOND_DEFAULT,
  LIMITED_SHORT_DIAMOND_DEFAULT,
  LIMITED_IMAGE_DIAMOND_DEFAULT,
  SHORT_VIDEO_DURATION_SECONDS,
} from '../RemoteConfigKeys.js';

import setPostDraftData from '../action/setPostDraftData.js';
import addModal from '../action/addModal.js';
import processPostDraftFiles from '../action/processPostDraftFiles.js';

import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { PostDraftField, UploadJobType } from '../resource/uploadConstants.js';
import getIsShortVideo from '../resource/getIsShortVideo.js';
import getVideoDuration from '../resource/getVideoDuration.js';

const MODAL_ID = 'PostDraft';

/**
 * Open post draft
 * @kind action
 * @param {AssetPurpose} {purpose} - assets purpose.
 * @param {array} {files} - files.
 * @param {UploadJobType} {uploadJobType} - upload job type.
 * @return {Promise} Action promise.
 */
const openPostDraft =
  ({ purpose, files = [], uploadJobType } = {}) =>
  async (dispatch, getState) => {
    dispatch(
      setPostDraftData({
        key: PostDraftField.UPLOAD_JOB_ID,
        payload: {
          value: v4(),
        },
      })
    );
    await dispatch(
      processPostDraftFiles({
        purpose,
        files,
      })
    );
    const isValid = getOperationData(
      getState(),
      ['postDraft', purpose],
      'isValid'
    );
    if (!isValid) {
      return dispatch({ type: '' });
    }
    const isStory = UploadJobType.STORY === uploadJobType;
    const isImage = files[0]?.type?.startsWith('image/');
    const isVideo = files[0]?.type?.startsWith('video/');
    const isMultipleImages = isImage && files.length > 1;
    const isShortVideo =
      !isStory &&
      isVideo &&
      getIsShortVideo({
        duration: await getVideoDuration({ file: files[0] }),
        shortVideoMaxSeconds: getRemoteConfigData(
          getState(),
          SHORT_VIDEO_DURATION_SECONDS
        ),
      });

    // Pick the default-price key by the same media split as the price slider.
    //   Story → image: LIMITED_IMAGE / video: LIMITED_SHORT
    //   Post  → single image: POST_IMAGE / multiple images: POST_IMAGES
    //           short video: POST_SHORT / long video: POST_VIDEO
    const defaultPriceKey = isStory
      ? isImage
        ? LIMITED_IMAGE_DIAMOND_DEFAULT
        : LIMITED_SHORT_DIAMOND_DEFAULT
      : isImage
        ? isMultipleImages
          ? POST_IMAGES_DIAMOND_DEFAULT
          : POST_IMAGE_DIAMOND_DEFAULT
        : isShortVideo
          ? POST_SHORT_DIAMOND_DEFAULT
          : POST_VIDEO_DIAMOND_DEFAULT;
    dispatch(
      setPostDraftData({
        key: PostDraftField.UNLOCK_PRICE,
        payload: {
          value: getRemoteConfigData(getState(), defaultPriceKey),
        },
      })
    );
    return dispatch(
      addModal({
        id: MODAL_ID,
        prevId: 'UploadMenuModal',
        isHigherThanAll: true,
        transitionStatus: 'opening',
      })
    );
  };

export default openPostDraft;
